module.exports = __webpack_public_path__ + "static/media/redcircle.2ade2d5c.png";